// To store all the events
// Basically done to avoid typos

const ACTIONS = {
  JOIN: "join",
  JOINED: "joined", // confirmation of joining
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "code-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
};

module.exports = ACTIONS; // common js syntax
